import React from 'react';

import type { ExtensionParams } from '@atlaskit/editor-common/extensions/extension-handler';
import { RedactionPlaceholder } from '@atlassian/guard-redaction-ui/scribble/placeholder';

import { expValEquals } from '@confluence/feature-experiments';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { RedactionExtensionParams } from '../redaction-constants.ts';

// Rendered while the redaction chunk loads. When the shared scribble
// is enabled we reserve its exact inline footprint so the surrounding text does
// not shift when the bar mounts; the legacy solid-bar path renders nothing here
// (its own fallback box is sized inline once mounted).
export const RedactionLoading = (): React.JSX.Element | null =>
	expValEquals('confluence_redaction_shared_scribble_exp', 'isEnabled', true) ? (
		<RedactionPlaceholder />
	) : null;

export const TourableRedactionExtensionLoader: LoadableType<{
	contentId?: string | null;
	extensionNode: ExtensionParams<RedactionExtensionParams>;
	isCommentContext?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TourableRedactionExtension" */ './TourableRedactionExtension.tsx'
			)
		).TourableRedactionExtension,
	loading: RedactionLoading,
});
